// extracted by mini-css-extract-plugin
export default {"container":"XGQ0e"};